<template>
  <div class="header">
    <div class="header-content">
      <div class="header-logo">
        <img :src="`${url}/logo.png`" alt="logo" />
      </div>
      <div class="tabs">
        <div 
          @click="handleClick(tab)" 
          class="tab-item" 
          v-for="tab in tabs" 
          :key="tab.name" 
          :class="{
            'active': isActiveTab(tab),
            'has-dropdown': tab.children
          }"
        >
          {{tab.name}}
          <div v-if="tab.children"   class="dropdown-menu" :class="{'show': activeDropdown === tab.name,'longmenu': activeDropdown === '宣传运营'}">
            <div 
              v-for="(child, index) in tab.children" 
              :key="child"
              @click.stop="handleChildClick(tab.name, child, index)"
              class="dropdown-item"
            >
              {{child.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { url } from '@/api'
import { useRoute, useRouter } from 'vue-router'
import { featureTabs, developmentTabs } from '@/utils/publicJson'
const route = useRoute()
const router = useRouter()
const activeDropdown = ref(null)

const tabs = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '宣传运营',
    path: '/promotion',
    children: featureTabs
  },
  {
    name: '产品开发',
    path: '/development',
    children: developmentTabs
  },
  {
    name: '关于我们',
    path: '/about'
  }
]
const handleClick = (tab) => {
  if (tab.children) {
    activeDropdown.value = activeDropdown.value === tab.name ? null : tab.name
  } else {
    activeDropdown.value = null
    router.push(tab.path)
  }
}

const handleChildClick = (tabName, child, index) => {
  activeDropdown.value = null
  if (tabName === '产品开发') {
    router.push({
      path: '/case',
      query: {
        serviceIndex: index + 1,
      }
    })
    return
  }
  if (tabName === '宣传运营') {
    if (child.path) {
      router.push(child.path)
    }
    return
  }
}

const isActiveTab = (tab) => {
  if (tab.path === '/') {
    return route.path === '/'
  } else if (tab.path === '/promotion') {
    return route.path.startsWith('/promotion')
  } else if (tab.path === '/development') {
    return route.path.startsWith('/development') || route.path.startsWith('/case')
  } else {
    return route.path.startsWith(tab.path)
  }
}

</script>
<style lang="scss" scoped>
.header{
  position: sticky;
  height: 120px;
  padding: 0 170px;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-shadow: 0px 0px 43px 0px rgba(183,183,183,0.25);
  background: #fff;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
  

  
  .header-logo{
    img{
      width: 308px;
      height: 106px;
    }
  }
  .tabs{
    display: flex;
    align-items: center;
    height: 100%;
    .tab-item{
      position: relative;
      font-weight: bold;
      margin-left: 30px;
      width: 106px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: #333;
      font-size: 18px;
      cursor: pointer;
      z-index: 1;
    }
    .active{
      width: 105px;
height: 55px;
background: linear-gradient( 140deg, #FA932A 0%, #FA5F31 100%);
border-radius: 57px 57px 57px 57px;
      font-size: 18px;
      color: #fff;
      position: relative;
      z-index: 1001;
   
    }
    
    .has-dropdown {
      .dropdown-menu {
        position: absolute;
        top: 100px;
        left: 50%;
        // height: 340px;
        height: auto;
        right: 0;
        margin: auto;
        // background: url('https://xiaolu-pm.oss-cn-hangzhou.aliyuncs.com/xiaolu-website/home/development_bg.png') no-repeat;
        background: url('https://xiaolu-pm.oss-cn-hangzhou.aliyuncs.com/xiaolu-website/home/development_bg.png') no-repeat;
        background-size: 100% 100%;
        transform: translateX(-50%);
        width: 171px;
        border-radius: 4px;
        padding: 8px 10px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
        z-index: 1000;
        pointer-events: none;
        
        &.show {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
        }
        
        .dropdown-item {
         height: 44px;
         margin: 2px 0;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          line-height: 44px;
          transition: all 0.2s ease;
          white-space: nowrap;
          
          &:hover {
            color: #FA5F31;
            border-radius: 5px;
            background: #fff;
          }
        }
      }
      .longmenu{
        height: auto;
        // background: url('https://xiaolu-pm.oss-cn-hangzhou.aliyuncs.com/xiaolu-website/home/promotion_bg.png') no-repeat;
        background-size: 100% 100%;

      }
    }
  }
}
</style>
